var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-left":"2vw"},attrs:{"id":"footer"}},[_c('router-link',{staticClass:"transparent z-depth-0 pink-text text-lighten-3 waves-effect waves-black",attrs:{"to":{ name: 'impressum' }}},[_vm._v("Impressum")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }